
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, } from "@/components/ui/card";
import { Link } from "@tanstack/react-router";


const PageNotFound = () => {
    return (
        // Contenedor padre: ocupa toda la pantalla, tiene el fondo
        <div className="h-screen w-screen bg-[url('/images/background.jpg')] bg-cover bg-center bg-no-repeat flex items-center justify-center p-4 bg-fixed">
            {/* Card centrado encima del fondo */}
            <Card className="relative z-10 flex flex-col md:flex-row w-full max-w-4xl bg-white/80 dark:bg-black/80 backdrop-blur-md rounded-xl shadow-xl overflow-hidden">
                {/* Contenido del Card */}
                <div className="w-full md:w-1/2 p-6 flex flex-col">
                    <CardHeader>
                        <CardTitle className="font-outfit text-4xl">
                            <img src="/images/Logo-light.png" className="block dark:hidden" alt="" />
                            <img src="/images/Logo-dark.png" className="hidden dark:block" alt="" />
                        </CardTitle>
                        <CardDescription className="py-3 font-nunito justify-center" />
                        <div className="grid p-3">
                        
                        </div>

                    </CardHeader>


                    <>
                        <CardContent className="flex">
                            <Card className="w-full max-w-full mx-auto">
                                <CardHeader>
                                    <CardTitle className="text-lg text-center font-outfit">Esta ruta no existe!</CardTitle>
                                </CardHeader>
                                <CardContent className="text-center text-red-500">
                                        <Link to="/dashboard" >Volver al inicio</Link>
                                </CardContent>
                            </Card>
                        </CardContent>
                        <CardFooter className="pt-0" />
                    </>

                </div>



            </Card>
        </div>
    );



};

export default PageNotFound;
